// src/pages/PasswordReset.jsx
// React 组件版本（JavaScript/JSX）
import React, { useEffect, useState } from 'react';

const PasswordReset = () => {
  const [message, setMessage] = useState('正在跳转到应用...');

  useEffect(() => {
    const redirect = () => {
      try {
        // 获取 URL hash 中的参数
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');
        
        if (accessToken && refreshToken) {
          // 构建 deep link
          const deepLink = `timedetective://password-reset#access_token=${encodeURIComponent(accessToken)}&refresh_token=${encodeURIComponent(refreshToken)}`;
          
          // 尝试打开 APP
          window.location.href = deepLink;
          
          // 1.5秒后显示备用提示
          setTimeout(() => {
            setMessage('如果没有自动跳转，请确保已安装 Time Detective APP');
          }, 1500);
        } else {
          setMessage('❌ 链接无效或已过期，请重新申请密码重置');
        }
      } catch (error) {
        setMessage(`❌ 发生错误: ${error.message}`);
      }
    };

    redirect();
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>🔐 Time Detective</h2>
        <div style={styles.spinner} />
        <p style={styles.message}>{message}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
    textAlign: 'center',
    padding: '50px 20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    minHeight: '100vh',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    maxWidth: '400px',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '40px',
    borderRadius: '20px',
    backdropFilter: 'blur(10px)',
  },
  title: {
    marginTop: 0,
    fontSize: '24px',
  },
  spinner: {
    border: '3px solid rgba(255, 255, 255, 0.3)',
    borderTop: '3px solid white',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
    margin: '20px auto',
  },
  message: {
    marginTop: '20px',
    lineHeight: '1.6',
  },
};

// 添加 CSS 动画
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

export default PasswordReset;

